<template>
  <div>
    <div class="d-flex align-items-center mb-4 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات خریدار</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <div class="mb-4">
        <BaseText :showError="nameError" :required="true" errortext="وارد کردن نام الزامی است" @input="addFactorData.firstName = $event" title="نام" placeholder="نام" />
      </div>
      <div class="mb-4">
        <BaseText
          :showError="lastNameError"
          :required="true"
          errortext="وارد کردن نام خانوادگی الزامی است"
          @input="addFactorData.lastName = $event"
          title="نام خانوادگی"
          placeholder="نام خانوادگی"
        />
      </div>
      <div class="mb-4">
        <BaseText
          :showError="phoneError || phoneResponseErr"
          :required="true"
          :errortext="phoneError ? 'وارد کردن تلفن همراه الزامی است' : phoneResponseText"
          :maxlength="12"
          @input="addFactorData.mobile = $event"
          inputType="number"
          title="تلفن همراه"
          placeholder="تلفن همراه"
        />
      </div>
      <div class="mb-4">
        <ComboBox
          @loadMoreData="loadMoreCompanyData"
          @searchedItem="searchCompany($event)"
          :searchedData="companyList"
          @selectedItem="selectCompany"
          :disabled="!isFormal"
          @buttonAction="openCompanyModal"
          :classes="`${isFormalClass}`"
          :selectedValue="companyName"
          :pagination="true"
          :hasButton="true"
          buttonText="+ اضافه کردن شرکت"
          itemClass="__item py-2"
          title="شرکت"
          placeholder="شرکت"
          :showError="companyError"
          :required="true"
          errortext="انتخاب کردن شرکت الزامی است"
        />
      </div>
    </div>
    <div class="d-flex align-items-center mb-4 p-0">
      <div class="d-flex align-items-center">
        <span class="sectionTitle">اطلاعات پستی</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="section">
      <b-row>
        <b-col class="mb-4">
          <div v-if="forceUpdateFlag">
            <ComboBox
              title="استان"
              placeholder="استان"
              @selectedItem="selectedProvince($event)"
              @searchedItem="searchedProvince($event)"
              :searchedData="searchedProvinceData"
              @input="selectProvince = $event"
              :selectedValue="selectProvince"
            />
          </div>
        </b-col>
        <b-col>
          <div v-if="resetCityFlag">
            <ComboBox
              title="شهر"
              placeholder="شهر"
              :disabled="disableCity"
              @selectedItem="selectedCity($event)"
              @searchedItem="searchedCity($event)"
              :searchedData="searchedCityData"
              @input="selectCity = $event"
              :selectedValue="selectCity"
            />
          </div>
        </b-col>
      </b-row>
      <div class="mb-4">
        <TextAreaInput @input="addFactorData.address.addressText = $event" title="آدرس" placeholder="آدرس" />
      </div>
      <div class="mb-4">
        <BaseText :maxlength="10" @input="addFactorData.address.postalCode = $event" inputType="number" title="کد پستی" placeholder="کد پستی" />
      </div>
      <b-modal v-model="modalCompany" centered hide-footer body-class="p-0" title="اطلاعات شرکت">
        <div class="p-3">
          <div class="mb-3">
            <BaseText
              @input="addModalCustomerData.Name = $event"
              :required="true"
              inputType="text"
              title="عنوان شرکت"
              placeholder="عنوان شرکت"
              :showError="companyNameError"
              errortext="وارد کردن عنوان شرکت الزامی است"
            />
          </div>
          <div class="mb-3">
            <BaseText
              @input="addModalCustomerData.phoneNumber = $event"
              :required="true"
              inputType="number"
              :maxlength="12"
              classes="mt-2"
              title="تلفن"
              placeholder="تلفن"
              :showError="companyPhoneError"
              errortext="وارد کردن تلفن الزامی است"
            />
          </div>
          <div class="mb-3">
            <BaseText
              @input="addModalCustomerData.economicalNumber = $event"
              :required="true"
              inputType="text"
              classes="mt-2"
              title="شماره اقتصادی"
              placeholder="شماره اقتصادی"
              :showError="companyEconomicNumberError"
              errortext="وارد کردن شماره اقتصادی الزامی است"
            />
          </div>
          <div class="mb-3">
            <BaseText
              @input="addModalCustomerData.nationalRegistrationNumber = $event"
              :required="true"
              inputType="text"
              classes="my-2"
              title="شماره ثبت ملی"
              placeholder="شماره ثبت ملی"
              :showError="companyMelliCodeError"
              errortext="وارد کردن شماره ثبت ملی الزامی است"
            />
          </div>
          <div class="button-wrapper">
            <div @click="modal.company = false" class="me-2">
              <Button text="انصراف" btnClass="cancel btn-border" />
            </div>
            <div @click="createCompany">
              <Button :loading="companyLoading" text="ثبت" btnClass="aprove btn-border" />
            </div>
          </div>
        </div>
      </b-modal>
      <b-row>
        <b-col class="deactiveUser" lg="4"></b-col>
        <b-col lg="8">
          <div class="buttonClass">
            <Button @click.native="addFactor" :loading="submitLoading" text="ثبت" btnClass="aprove btn-border" />
            <div @click="showAddCustomerModal" class="me-2">
              <Button text="انصراف" btnClass="cancel btn-border" />
            </div>
            <b-modal ref="add-customer" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
              <div class="error-wrapper">
                <div class="mb-4">
                  <img src="@/assets/images/checked1.svg" />
                </div>
                <div class="error-title">
                  آیا از انصراف خود مطمئن هستید؟
                </div>
                <div class="buttons">
                  <button @click="cancleAddCustomerModal" class="cancelButton">خیر</button>
                  <button @click="cancleAddButton" class="approveButton">بلی</button>
                </div>
              </div>
            </b-modal>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Button from '../../common/Button.vue'
import { invoiceMixins, searchComboMixins } from '../../../utils/mixins'
import invoiceDataProvider from '../../../services/invoice'

export default {
  name: 'add-customer',
  mixins: [invoiceMixins, searchComboMixins],
  components: {
    BaseText,
    ComboBox,
    TextAreaInput,
    Button,
  },
  props: {
    disable: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      companyNameError: false,
      companyPhoneError: false,
      companyEconomicNumberError: false,
      companyMelliCodeError: false,
      phoneError: false,
      phoneResponseErr: false,
      phoneResponseText: '',
      lastNameError: false,
      nameError: false,
      companyError: false,
      forceUpdateFlag: true,
      resetCityFlag: true,
      companyLoading: false,
      submitLoading: false,
      allowCompanySubmit: true,
      searchedProvinceData: [],
      searchedCityData: [],
      selectProvince: '',
      selectCity: '',
      modalCompany: false,
      disableCity: true,
      companyName: '',
      addCustomer: {
        type: 'company',
        text: '+ اضافه کردن شرکت',
      },
      companyPagination: {
        pageNumber: 1,
        pageSize: 10,
        keyword: '',
      },
      addCompanyModal: false,
      addFactorData: {
        firstName: '',
        lastName: '',
        mobile: '',
        adminNote: '',
        companyId: null,
        address: {
          cityId: null,
          addressText: '',
          postalCode: '',
        },
      },
      addModalCustomerData: {
        Name: '',
        phoneNumber: '',
        economicalNumber: '',
        nationalRegistrationNumber: '',
      },
    }
  },
  beforeMount() {
    this.getCompanies(this.companyPagination, 1)
    this.forceUpdateFlag = false
    this.$nextTick(() => {
      invoiceDataProvider
        .getProvince({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
        })
        .then(res => {
          this.$store.dispatch('invoice/setProvinceData', res.data.data)
          this.searchedProvinceData = this.provinceData
        })
      this.forceUpdateFlag = true
    })
    setTimeout(() => {
      if (this.selectedCompany) {
        this.setIsFormal(false)
        this.companyName = this.selectedCompany.value
      }
    }, 400)
  },
  computed: {
    isFormalClass() {
      if (!this.isFormal) {
        return 'invoice-disable'
      } else {
        return ''
      }
    },
    companyListData() {
      return this.$store.state.invoice.companyList
    },
  },
  methods: {
    addFactor() {
      this.phoneError = false
      this.lastNameError = false
      this.nameError = false
      this.phoneResponseErr = false
      this.companyError = false
      if (!this.addFactorData.firstName) {
        this.nameError = true
      }
      if (!this.addFactorData.lastName) {
        this.lastNameError = true
      }
      if (!this.addFactorData.mobile) {
        this.phoneError = true
      }

      if (!this.selectedCompany && this.isFormal) {
        this.companyError = true
        return
      } else {
        if (this.addFactorData.mobile && this.addFactorData.lastName && this.addFactorData.firstName) {
          this.submitLoading = true
          invoiceDataProvider
            .addPeaple(this.addFactorData)
            .then(res => {
              this.$emit('changeComponent', false)
              this.$emit('updateCustomerList', true)
              this.phoneResponseErr = false
              this.submitLoading = false
            })
            .catch(err => {
              if (err.response.status == 409) {
                this.phoneResponseErr = true
                this.submitLoading = false
                this.phoneResponseText = err.response.data.message
              }
            })
        }
      }
    },
    openCompanyModal() {
      this.companyName = null
      this.modalCompany = true
    },
    closeAddCustomerModal() {
      this.$refs['add-company'].hide()
    },
    cancleAddButton() {
      this.$emit('backToFactor', false)
    },
    showAddCustomerModal() {
      this.$refs['add-customer'].show()
    },
    cancleAddCustomerModal() {
      this.$refs['add-customer'].hide()
    },
    selectedProvince(event) {
      this.resetCityFlag = false
      this.$nextTick(() => {
        this.resetCityFlag = true
      })
      this.selectProvince = event.value
      this.selectCity = ''
      invoiceDataProvider
        .getCity({
          pageSize: 1000,
          pageNumber: 1,
          keyword: '',
          ProvinceId: event.key,
        })
        .then(res => {
          this.$store.dispatch('invoice/setCityData', res.data.data)
          this.searchedCityData = this.cityData
          this.disableCity = false
        })
    },
    searchedProvince(event) {
      this.searchedProvinceData = this.provinceData
      this.searchedProvinceData = this.provinceData.filter(item => {
        return item.value.includes(event)
      })
    },
    selectedCity(event) {
      this.selectCity = event.value
      this.addFactorData.address.cityId = event.key
    },
    searchedCity(event) {
      this.searchedCityData = this.cityData
      this.searchedCityData = this.cityData.filter(item => {
        return item.value.includes(event)
      })
    },
    createCompany() {
      this.companyNameError = false
      this.companyPhoneError = false
      this.companyEconomicNumberError = false
      this.companyMelliCodeError = false
      if (!this.addModalCustomerData.Name) {
        this.companyNameError = true
      }
      if (!this.addModalCustomerData.phoneNumber) {
        this.companyPhoneError = true
      }
      if (!this.addModalCustomerData.economicalNumber) {
        this.companyEconomicNumberError = true
      }
      if (!this.addModalCustomerData.nationalRegistrationNumber) {
        this.companyMelliCodeError = true
      } else {
        this.companyLoading = true
        if (this.allowCompanySubmit) {
          this.allowCompanySubmit = false
          invoiceDataProvider
            .createCompany({
              name: this.addModalCustomerData.Name,
              phoneNumber: this.addModalCustomerData.phoneNumber,
              economicalNumber: this.addModalCustomerData.economicalNumber,
              nationalRegistrationNumber: this.addModalCustomerData.nationalRegistrationNumber,
            })
            .then(res => {
              this.modalCompany = false
              this.companyLoading = false
              this.allowCompanySubmit = true
              this.getCompanies(this.companyPagination, 2)
              setTimeout(() => {
                this.companyName = this.addModalCustomerData.Name
                let companyId = res.data.data.companyId
                this.setSelectedCompany({ key: companyId, value: this.companyName })
              }, 500)
            })
        }
      }
    },
    getCompanies(paginationData, type) {
      invoiceDataProvider
        .getAllCompanies(paginationData)
        .then(res => {
          if (type === 1) {
            this.$store.dispatch('invoice/setCompanyList', res.data.data)
          } else if (type === 2) {
            this.$store.dispatch('invoice/setSearchedCompanyList', res.data.data)
          }
        })
        .catch(err => {
          
        })
    },
    loadMoreCompanyData() {
      if (this.companyList.length <= this.companyPagination.pageNumber) {
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.forceUpdateFlag = true
          this.getCompanies(this.companyPagination, 1)
        })
      } else {
        this.companyPagination.pageNumber++
        this.forceUpdateFlag = false
        this.$nextTick(() => {
          this.getCompanies(this.companyPagination, 3)
          this.forceUpdateFlag = true
        })
      }
    },
    searchCompany(searchedValue) {
      this.companyPagination.keyword = searchedValue
      this.companyPagination.pageNumber = 1
      setTimeout(() => {
        this.getCompanies(this.companyPagination, 2)
      }, 500)
    },
    selectCompany(company) {
      this.$store.commit(`searchCombo/SET_SELECTED_COMPANY`, company)
      this.companyName = company.value
      this.agentPagination.companyId = company.key
      // TODO this.agentDisable = false
      // this.getAgent(this.agentPagination)
    },
  },
}
</script>

<style scoped lang="scss">
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
::v-deep .custom-control-label {
  margin-right: 5px;
}
::v-deep .modal-dialog {
  max-width: 540px !important;
}
::v-deep .modal-backdrop {
  background-color: rgba(19, 19, 19, 0.9) !important;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.invoice-disable {
  color: rgba(73, 80, 87, 0.4) !important;
  span {
    color: rgba(73, 80, 87, 0.4) !important;
  }
}
.__item {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
}
.section {
  padding: 26px 30px;
  margin-bottom: 20px;
  background: #f8f9fa;
  border-radius: 6px;
}

.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.deactiveUser {
  display: flex;
  align-items: center !important;
  padding-right: 0;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.submitButton {
  font-size: 14px;
  padding: 8px 45px;
  color: white;
  background: #556ee6;
  border: 1px solid #556ee6;
  box-sizing: border-box;
  border-radius: 4px;
}
.cancleButton {
  display: flex;
  margin-left: 10px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 23px;
  background: #74788d;
  box-sizing: border-box;
  border-radius: 4px;
}
.deleteTitle {
  color: gray;
  margin-right: 5px;
}
.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px !important;
    margin-left: 12px !important;
    color: white !important;
    background: #74788d !important;
    border-radius: 4px !important;
  }
}
</style>
